module.exports = __webpack_public_path__ + "img/airas-sub-features-2.0d8dfc0.jpg";